import { createTheme, MantineColorsTuple } from "@mantine/core";

const invy: MantineColorsTuple = [
  '#FDF2F2',
  '#F9E1E1',
  '#F4C8C8',
  '#EFAEAE',
  '#E99191',
  '#E47777',
  '#DE5B5B',
  '#C85252',
  '#B24949',
  '#9B4040',
]

export const mantineTheme = createTheme({
  colors: { invy },
  primaryColor: 'invy',
})
